export default {
  name: "Alcohol",
  width: 32,
  height: 32,
  viewBox: "0 0 32 32",
  path: {
    d:
      "M22 12.72V5c0-1.1-.9-2-2-2h-8c-1.1 0-2 .9-2 2v7.72c0 3.32 2.01 5.74 5 6.19v8.38h-2.35c-.55 0-1 .45-1 1s.45 1 1 1h6.7c.55 0 1-.45 1-1s-.45-1-1-1H17V18.9c2.99-.44 5-2.86 5-6.18zm-10 0V5h8v7.72c0 2.54-1.61 4.26-4 4.28-2.39-.02-4-1.74-4-4.28z",
  },
}
